module.exports = __webpack_public_path__ + "assets/img/tiyan3.ccb7ca1e.png";